module.exports = __webpack_public_path__ + "static/img/samajuri (34).c2d71a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (34).jpg
// module id = tz0d
// module chunks = 0